import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.is-extensible";
import staticQueryData from "../../../../.docz/public/static/d/1803957048.json";
export var useDbQuery = function useDbQuery() {
  try {
    var data = staticQueryData.data;
    return JSON.parse(data.doczDb.db);
  } catch (err) {
    console.error(err);
    console.error('Error when parsing docz database');
    return {};
  }
};

if (typeof useDbQuery !== 'undefined' && useDbQuery && useDbQuery === Object(useDbQuery) && Object.isExtensible(useDbQuery) && !useDbQuery.hasOwnProperty('__filemeta')) {
  Object.defineProperty(useDbQuery, '__filemeta', {
    configurable: true,
    value: {
      name: "useDbQuery",
      filename: "node_modules/gatsby-theme-docz/src/hooks/useDbQuery.js"
    }
  });
}